// src/services/reservationHotelService.js
import api from "./api";

const reservationHotelService = {
  /**
   * Créer une DEMANDE de séjour (ton workflow: EN_ATTENTE, pas d'hotelId obligé)
   * Backend: POST /api/reservations/hotels/request
   */
  createRequest: async (payload) => {
    try {
      const res = await api.post("/reservations/hotels/request", payload);
      return res.data; // { success, message, data }
    } catch (err) {
      throw err;
    }
  },

  /**
   * Liste des demandes d'un utilisateur (si connecté)
   * GET /api/reservations/hotels/user/:userId
   */
  getByUserId: async (userId) => {
    try {
      const res = await api.get(`/reservations/hotels/user/${userId}`);
      return res.data;
    } catch (err) {
      throw err;
    }
  },

  /**
   * Détail d'une demande
   * GET /api/reservations/hotels/:id
   */
  getById: async (id) => {
    try {
      const res = await api.get(`/reservations/hotels/${id}`);
      return res.data;
    } catch (err) {
      throw err;
    }
  },
};

export default reservationHotelService;
